import post from '@app-src/data/api/post-to-api'
import { NativeLeadType } from '@app-src/data/leads/types'

/**
 * submitLeadCommunication
 * @description submits a request for lead communication (sms/text message)
 * @param {Number} callToAction - the call to action (value-report-speak) resulting in this message request
 * takes an object with these members:
 * @param {Object} lead - the native lead format
 */
const submitLeadCommunication = async ({
  callToActionType,
  lead,
  ...extraMiddleware
}: {
  callToActionType: number
  lead: NativeLeadType
}): Promise<Response> =>
  post({
    fetchContext: 'Submit Lead Communication',
    ...extraMiddleware
  })(
    'value-report/api',
    `v1/ValueReport/SubmitLeadCommunication/${callToActionType}`,
    lead
  )

export default submitLeadCommunication
